<template>
  <section class="faq-wrapper" id="faq">
    <div class="content-w">
      <div class="content">
        <div class="page-title">
          <img src="@/assets/svg/faq-title.svg" alt="Ответы на вопросы" />
        </div>

        <div class="wrapper-info">
          <div class="accordion-wrapper">
            <div class="accordion" role="tablist">
              <b-card
                no-body
                class="mb-1"
                v-for="(question, index) in questions"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    v-b-toggle="'accordion-' + index"
                    variant="info"
                  >
                    <span>{{ question.question }}</span>
                  </b-button>
                </b-card-header>

                <b-collapse
                  :id="'accordion-' + index"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text v-html="question.answer"> </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>

          <div class="feedback-wrapper">
            <div class="header">
              <h3>Остались вопросы?</h3>
            </div>

            <form ref="form" class="modal-form" @submit.stop.prevent="submit">
              <b-form-group
                id="name-input"
                label-for="name-input"
                invalid-feedback="Некорректное имя"
              >
                <b-form-input
                  id="name-input"
                  placeholder="Имя"
                  required
                  type="text"
                  pattern="[A-Za-z]+"
                  v-model="$v.item.name.$model"
                  :state="validateState($v.item.name)"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label-for="name-input"
                :invalid-feedback="invalidEmail"
              >
                <b-form-input
                  id="name-input"
                  placeholder="E-mail"
                  type="email"
                  required
                  :class="{
                    'is-invalid': isInvalidEmail,
                    'is-valid': !isInvalidEmail,
                  }"
                  v-model="$v.item.email.$model"
                  :state="validateState($v.item.email)"
                ></b-form-input>

                <!-- <span class="input-icon"
                      v-if="!item.email">*</span> -->
              </b-form-group>

              <b-form-group
                class="position-relative"
                id="select-input"
                label-for="select-input"
                invalid-feedback="Выберите тему"
              >
                <b-form-input
                  readonly
                  id="select-input"
                  @click="list = !list"
                  placeholder="Выберите тему"
                  required
                  class="select"
                  :class="{ active: list }"
                  type="text"
                  v-model="$v.item.subject.$model"
                  :state="validateState($v.item.subject)"
                ></b-form-input>

                <!-- <span class="input-icon"
                      v-if="!item.subject">*</span> -->

                <div class="select-list" v-if="list">
                  <div
                    class=""
                    v-for="option in options"
                    :key="option.name"
                    @click="setSubject(option.name)"
                    ref="optionText"
                  >
                    {{ option.name }}
                  </div>
                </div>

                <img
                  src="@/assets/svg/arrow-bottom.svg"
                  class="select-icon"
                  v-if="!list"
                  loading="lazy"
                />

                <img
                  src="@/assets/svg/arrow-top.svg"
                  class="select-icon"
                  v-if="list"
                  loading="lazy"
                />
              </b-form-group>

              <b-form-group
                class="position-relative"
                id="textarea"
                label-for="textarea"
                invalid-feedback="Опишите проблему"
              >
                <b-form-textarea
                  id="textarea"
                  placeholder="Текст сообщения"
                  rows="3"
                  class="textarea"
                  max-rows="6"
                  invalid-feedback="Опишите проблему"
                  v-model="$v.item.msg.$model"
                  :state="validateState($v.item.msg)"
                  required
                ></b-form-textarea>

                <!-- <span class="input-icon"
                      v-if="!item.msg">*</span> -->
              </b-form-group>

              <b-form-checkbox
                id="checkbox-policies"
                class="mt-3"
                v-model="$v.item.policies.$model"
                :state="validateState($v.item.policies)"
                name="policies"
                value="true"
                unchecked-value="not_on"
              >
                Я прочитал и принял
                <b-link :href="privacyPolicyLink" target="_blank"
                  >политику конфиденциальности</b-link
                >
                и даю свое
                <b-link :href="personalDataLink" target="_blank"
                  >согласие</b-link
                >
                на обработку персональных данных
              </b-form-checkbox>

              <div class="w-100 d-flex justify-content-center mt-4">
                <div id="captcha-container"></div>

                <span v-if="isInvalidCaptcha" class="invalid-text">{{
                  this.invalidCaptcha
                }}</span>
              </div>
            </form>

            <b-button
              class="button button-gold"
              type="submit"
              :disabled="disabledBtn || submittedBtn"
              @click="submit"
              onclick="ym(108239013,'reachGoal','Click_feedback')"
              >Отправить</b-button
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { mapGetters, mapMutations } from "vuex";
import { helpers, minLength, required } from "vuelidate/lib/validators";

const text = helpers.regex("text", /^[?!,.а-яА-ЯёЁ\s]+$/);
const email = helpers.regex("email", /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);

export default {
  props: ["thanksText", "thanksTitle"],

  name: "FaqSection",

  components: {
  },

  mixins: [validationMixin],

  validations: {
    item: {
      name: {
        required,
        minLength: minLength(2),
        text,
      },
      email: {
        required,
        minLength: minLength(4),
        email,
      },
      msg: {
        required,
        minLength: minLength(10),
      },
      subject: {
        required,
      },
      policies: {
        required,
      },
      recaptchaResponse: {},
    },
  },

  data() {
    return {
      item: {
        name: "",
        email: "",
        msg: "",
        subject: "",
        policies: "",
        recaptchaResponse: "",
      },
      recaptcha: null,
      list: "",
      personalDataLink: "",
      privacyPolicyLink: "",
      widgetId: null,
      token: "",
      submittedBtn: false,
      invalidEmail: "Некорректный email",
      isInvalidEmail: false,
      isInvalidCaptcha: false,
      invalidCaptcha: "",
      options: [
        { value: "Вопрос по акции", text: "Вопрос по акции" },
        { value: "Вопрос по призам", text: "Вопрос по призам" },
        { value: "Вопрос по правилам", text: "Вопрос по правилам" },
      ],
      questions: [],
    };
  },

  computed: {
    ...mapGetters({
      documents: "documents",
      storeRules: "rules",
      storePrivacyPolicy: "privacyPolicy",
      storePersonalData: "personalData",
      storeUserAgremeent: "userAgreement",
    }),

    disabledBtn() {
      if (this.$v.item.$anyError) return true;
    },
  },

  methods: {
    resetModal() {
      this.$v.$reset();

      ((this.item.name = ""),
        (this.item.email = ""),
        (this.item.msg = ""),
        (this.item.policies = ''),
        (this.submittedBtn = false),
        (this.item.subject = null),
        (this.item.recaptchaResponse = ""));

      this.resetCaptcha()

      this.$emit("getThanksText", "");
      this.$emit("getThanksTitle", "Ваше обращение принято!");

      this.$bvModal.show("thanks-feedback-modal");
    },

    closeModal() {
      this.$v.$reset();

      ((this.item.name = ""),
        (this.item.email = ""),
        (this.item.msg = ""),
        (this.item.policies = ''),
        (this.submittedBtn = false),
        (this.item.subject = null),
        (this.item.recaptchaResponse = ""));
    },

    getInfo() {
      this.$http.get("/reference/faq").then((response) => {
        this.questions = response.data.data;
      });
    },

    validateState(item) {
      const { $dirty, $error } = item;
      return $dirty ? !$error : null;
    },

    setSubject(optionText) {
      this.item.subject = optionText;

      this.list = false;
    },

    getOptions() {
      axios
        .get("feedback/topics", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "access-control-allow-origin": "*",
          },
        })
        .then((response) => {
          this.options = response.data.data;
        });
    },

    submit() {
      this.submittedBtn = true;
      this.$v.item.$touch();

      if (this.$v.item.$anyError) return false;

      axios
        .post("feedback/send", {
          name: this.item.name,
          email: this.item.email,
          letterSubject: this.item.subject,
          text: this.item.msg,
          accept_policies: this.item.policies,
          "smart-captcha-response": this.item.recaptchaResponse,
        })
        .then((response) => {
          ym(108239013, "reachGoal", "Click_feedback");
          this.resetModal();
        })
        .catch((error) => {
          this.submittedBtn = false;
          this.resetCaptcha()
          this.isInvalidEmail = !!error.response.data.errors.email;
          this.isInvalidCaptcha =
            !!error.response.data.errors["smart-captcha-response"];

          if (error.response.data.errors.email) {
            this.invalidEmail = String(error.response.data.errors.email);
          }

          if (error.response.data.errors.smart - captcha - response) {
            this.invalidCaptcha = String(
              error.response.data.errors["smart-captcha-response"],
            );
          }

          // if (error.response.data.message){
          //   this.$emit('getErrorText', error.response.data.message)

          //   this.$bvModal.show('error-modal')
          // }
        });
    },

    renderCaptcha() {
      this.widgetId = window.smartCaptcha.render("captcha-container", {
        sitekey: "ysc1_cS8OaHyfLaHdYM7azFhnM84ck956BhgzOAVycwjgc9863942",
        callback: this.onCaptchaPassed,
      });
    },
    onCaptchaPassed(token) {
      this.item.recaptchaResponse = token; // Store token for form submission
      this.$emit("validated", token);
    },
    resetCaptcha() {
      if (this.widgetId !== null) {
        window.smartCaptcha.reset(this.widgetId); // Reset for reuse
      }
    },
  },

  mounted() {
    this.getInfo();
    this.getOptions();

    setTimeout(() => {
      this.personalDataLink = this.storePersonalData.url;
      this.privacyPolicyLink = this.storePrivacyPolicy.url;
    }, 100);

    if (window.smartCaptcha) {
      this.renderCaptcha();
    } else {
      window.onSmartCaptchaLoad = this.renderCaptcha;
    }
  },
};
</script>

<style scoped lang="scss">
.faq-wrapper {
  z-index: 99;
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 127px;

  @media (max-width: 999px) {
    padding-bottom: 52px;
  }

  @media (max-width: 576px) {
    padding-bottom: 60px;
  }
}

.content-wrapper {
  padding: 0 20px;
  display: flex;
  justify-content: center;

  @media (max-width: 999px) {
    padding: 0px;
  }

  .content-w {
    display: flex;
    justify-content: center;
  }

  .content {
    max-width: 1123px;
    background-color: #f5f5f5;
    border-radius: 25px;
    border: 2px solid #e7e7e7;
    width: 100%;
    padding: 30px 80px;

    @media (max-width: 999px) {
      border-radius: 0;
    }

    @media (max-width: 576px) {
      padding: 15px 25px;
      padding-top: 0;
    }
  }
}

.page-title {
  z-index: 99;
  position: relative;

  img {
    width: 500px;
    margin-bottom: 30px;
    z-index: 99;
    position: relative;

    @media (max-width: 1200px) {
      width: 240px;
      margin-bottom: 30px;
    }

    @media (max-width: 999px) {
      width: 182px;
      margin-bottom: 30px;
    }

    @media (max-width: 750px) {
      width: 219px;
      margin-bottom: 30px;
    }
  }
}

.textarea {
  margin-top: 10px;
  min-height: 130px;
  padding: 15px 25px;

  &::placeholder {
    color: $dark-gray;
  }
}

.dropdown-button {
  width: 100%;
  background-color: $light-gray !important;
}

.select {
  height: 38px;
  width: 100%;
  position: relative;
  background-color: $light-gray;
  margin-bottom: 20px;
  transition: 0.1s all !important;

  &.active {
    border: 1px solid #cecece;
    border-bottom: none !important;
    border-radius: 25px 25px 0 0 !important;
  }
}

.select-icon {
  position: absolute;
  right: 0;
  top: 0;
  margin-right: 15px;
  margin-top: 21px;
}

.select-list {
  position: absolute;
  margin-top: -18px;
  width: 100%;
  z-index: 99999;
  border-top: none;
  border-radius: 0 0 25px 25px;
  background-color: $white;

  div {
    height: fit-content;
    display: flex;
    text-align: left;
    align-items: center;
    padding: 0 15px;
    padding-left: 25px;
    padding-bottom: 6px;
    background-color: $white;
    border-radius: 0 0 25px 25px;
    cursor: pointer;
    transition: 0.5s all;
    font-family: $regular;
    font-size: 14px;
    font-weight: 400;
    color: $lighter-black;
    opacity: 0.6;
    margin-top: 6px;

    &.active {
      background-color: $white;
      color: $green;
    }

    &:hover {
      background-color: $white;
      color: $green;
    }
  }
}

.button {
  margin-top: 40px;
  width: 100%;
  border: 1px solid $black !important;

  &:hover {
    opacity: 0.8 !important;
  }
}

.captcha {
  display: flex;
  justify-content: center;
  width: 100% !important;
  transform: scale(125%);
  margin-top: 20px;
  margin-bottom: 20px;

  @media (max-width: 400px) {
    transform: scale(100%);
  }

  @media (max-width: 350px) {
    transform: scale(90%);
  }
}

.wrapper-info {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 678px) {
    flex-direction: column;
  }
}

.feedback-wrapper {
  background-color: #00712f;
  margin-left: 13px;
  padding-left: 56px;
  padding-right: 56px;
  padding-top: 36px;
  padding-bottom: 21px;
  border-radius: 10px;

  @media (max-width: 999px) {
    padding-left: 21px;
    padding-right: 21px;
    padding-top: 24px;
    padding-bottom: 23px;
  }

  @media (max-width: 678px) {
    margin-left: 0;
    margin-top: 16px;
  }

  h3 {
    color: white;
    font-weight: 900;
    font-size: 28px;
    font-family: $regular !important;
    margin-bottom: 25px;
  }
}

.accordion-wrapper {
  width: 100%;
}

.button {
  max-width: 357px !important;
  margin-top: 33px !important;
}

.modal-form {
  max-width: 332px;

  @media (max-width: 999px) {
    max-width: 225px;
  }

  @media (max-width: 678px) {
    max-width: none;
  }
}

.invalid-feedback {
  text-align: left !important;
}
</style>
